import React from "react";
import "./Service.css";
import { useParams } from "react-router-dom";

const ServiceHeader = () => {
  const { slug } = useParams();
  const decodedSlug = slug ? decodeURIComponent(slug) : "";

  return (
    <div
      className="services-section-Header chakra-petch-bold"
      style={{
        position: "relative",
        minHeight: "280px",
        backgroundColor: "#0c0c0c",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* ── Ghost EZER — purely left side, behind text ── */}
      <div
        style={{
          position: "absolute",
          bottom: "-10px",
          left: "-10px",
          fontSize: "clamp(100px, 18vw, 200px)",
          fontWeight: 900,
          color: "transparent",
          WebkitTextStroke: "1px rgba(255,255,255,0.045)",
          whiteSpace: "nowrap",
          zIndex: 1,
          letterSpacing: "0.1em",
          pointerEvents: "none",
          userSelect: "none",
          lineHeight: 1,
        }}
      >
        EZER
      </div>

      {/* ── Tire track — sits in the transition zone ── */}
      <svg
        viewBox="0 0 80 280"
        style={{
          position: "absolute",
          left: "48%",
          top: "50%",
          transform: "translateY(-50%)",
          height: "110%",
          width: "auto",
          opacity: 0.05,
          zIndex: 2,
          pointerEvents: "none",
        }}
      >
        {[0, 13, 26, 39, 52, 65].map((x, i) => (
          <g key={i}>
            {[0, 36, 72, 108, 144, 180, 216, 252].map((y, j) => (
              <rect
                key={j}
                x={x}
                y={y}
                width="9"
                height="26"
                rx="2"
                fill="white"
              />
            ))}
          </g>
        ))}
      </svg>

      {/* ── Car image — right 55%, full bleed top/bottom ── */}
      <img
        src="/assets/service-bg/service-car.jpg"
        alt=""
        style={{
          position: "absolute",
          right: 0,
          top: "-8%",
          height: "116%",
          width: "58%",
          objectFit: "cover",
          objectPosition: "40% center",
          zIndex: 2,
          pointerEvents: "none",
          filter: "brightness(0.72) contrast(1.1) grayscale(10%)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, rgba(0,0,0,0.5) 15%, black 32%)",
          maskImage:
            "linear-gradient(to right, transparent 0%, rgba(0,0,0,0.5) 15%, black 32%)",
        }}
      />

      {/* ── Bottom ground fade ── */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "38%",
          background: "linear-gradient(to bottom, transparent, #0c0c0c)",
          zIndex: 4,
          pointerEvents: "none",
        }}
      />

      {/* ── Top fade ── */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "20%",
          background: "linear-gradient(to top, transparent, #0c0c0c)",
          zIndex: 4,
          pointerEvents: "none",
        }}
      />

      {/* ── Left solid guard — keeps text area clean ── */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          width: "42%",
          background:
            "linear-gradient(to right, #0c0c0c 80%, transparent 100%)",
          zIndex: 4,
          pointerEvents: "none",
        }}
      />

      {/* ── Vertical red accent line — left edge of car zone ── */}
      <div
        style={{
          position: "absolute",
          top: "15%",
          bottom: "15%",
          left: "43%",
          width: "2px",
          background:
            "linear-gradient(to bottom, transparent, #FD2906 25%, #FD2906 75%, transparent)",
          zIndex: 5,
          pointerEvents: "none",
        }}
      />

      {/* ── Text ── */}
      <div
        style={{
          position: "relative",
          zIndex: 6,
          padding: "2.5rem 3rem",
          maxWidth: "46%",
        }}
      >
        {/* Breadcrumb */}
        <div className="breadcrumb" style={{ marginBottom: "1rem" }}>
          <span className="services-section-home">HOME</span>
          <span className="separator">•</span>
          <span className="services-service">SERVICES</span>
        </div>

        {/* Red pill tag */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "10px",
          }}
        >
          <div
            style={{ width: "24px", height: "2px", backgroundColor: "#FD2906" }}
          />
          <span
            style={{
              fontSize: "10px",
              letterSpacing: "0.22em",
              color: "#FD2906",
              fontWeight: 700,
            }}
          >
            EZER AUTOMOTIVE
          </span>
        </div>

        {/* Page title */}
        <h1
          className="services-section-title"
          style={{
            margin: 0,
            lineHeight: 1.1,
            fontSize: "clamp(24px, 3.5vw, 42px)",
          }}
        >
          {decodedSlug || "OUR SERVICES"}
        </h1>

        {/* Bottom red underline accent */}
        <div
          style={{
            marginTop: "14px",
            width: "48px",
            height: "3px",
            background: "#FD2906",
            clipPath: "polygon(0 0, 100% 0, 85% 100%, 0 100%)",
          }}
        />
      </div>
    </div>
  );
};

export default ServiceHeader;
